'use client'

import {observer} from 'mobx-react'

import {PageType} from '@/src/core/domain/entities/page'

import {useStore} from '@/src/shared/hooks/useStore'
import {LayoutMeta} from '@/src/shared/ui/layout/ui/meta'
import {PageTitle} from '@/src/shared/ui/layout/ui/page-title'
import {LayoutUI} from '@/src/shared/ui/layout/ui/styles'
import styled from 'styled-components'

export const FuncTestingPageTitle = observer(() => {
  const {pageData} = useStore()

  let title: React.ReactNode = ''

  if (pageData!.type === PageType.FunctionalTesting) {
    title = 'Функциональное тестирование'
  } else if (pageData!.type === PageType.ShoeTesting) {
    title = 'Запись на подбор обуви'
  }

  return (
    <LayoutUI.Meta
      as={LayoutMeta}
      title={
        <PageTitleStyled>
          <h1>{title}</h1>
        </PageTitleStyled>
      }
      breadcrumbs={pageData!.breadcrumbs}
    />
  )
})

const PageTitleStyled = styled(PageTitle.__UI.Component)`
  justify-content: center;
`
